export const Colors = {
  orange: "orange",
  green: "green",
  blue: "blue",
  gray: "gray",
  black: "black",
};
